import React from 'react';

const Tabs = ({ TABS, activeTab, setActiveTab, S }) => {
  return (
    <div style={{ display: 'flex', padding: '0 32px', borderBottom: `1px solid ${S.borderLight}`, background: 'rgba(255,255,255,0.6)', flexShrink: 0 }}>
      {TABS.map(tab => (
        <button
          key={tab.id}
          onClick={() => setActiveTab(tab.id)}
          style={{
            padding: '14px 20px',
            fontSize: 13,
            fontWeight: activeTab === tab.id ? 600 : 500,
            color: activeTab === tab.id ? S.burgundy : S.textMuted,
            background: 'none',
            border: 'none',
            borderBottom: activeTab === tab.id ? `2px solid ${S.burgundy}` : '2px solid transparent',
            cursor: 'pointer',
          }}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default Tabs;
